const cards = {
    maxWidth: 300,
    borderWidth: 4
}

export default cards;